import React, { useEffect, useState } from "react";
import Popup from "../../designer/components/layout/Popup";
import SaveDesign from "../../designer/components/layout/SaveDesign";
import ShareDesign from "../../designer/components/layout/ShareDesign";
import { set } from "lodash";
import { APP_CONSTANTS } from "../../constants/AppConstants";
import { useParams } from "react-router-dom";
import RenameProject from "../../designer/components/layout/RenameProject";
import { getDesignInfoByUniqueId } from "../../designer/api/save-design.api";

// MERGE THIS WITH THE OLD SHARE AND SAVE COMPONENT
const ShareAndSave: React.FC<any> = ({
  setSaveSharePopup,
  isSaveDesignPopup,
}: any) => {
  const { designId } = useParams(); // Extract `designId` from the URL
  const [showSaveDesignPopUp, setSaveDesignPopup] = useState(true);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [shareURL, setShareURL] = useState("");
  const [existingDesignId, setExistingDesignId] = useState<string | null>(null);
  const [showRenamePopup, setShowRenamePopup] = useState(false);
  const handleSaveDesign = (saveDesignData: {
    email: string;
    designName: string;
    unique_id: string;
    designId: string;
  }) => {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get("userId");
    // If we are editing an existing design, append the URL accordingly
    const designIdToUse = existingDesignId || saveDesignData.unique_id;
    let urlToShare = `${APP_CONSTANTS.baseAPPURL}product-catalog/${
      saveDesignData.unique_id.split("-")[0]
    }/edit-designing/${designIdToUse}`;
    if (userId) {
      urlToShare += `?userId=${userId}`;
    }
    setShareURL(urlToShare);
    setShowSharePopup(true);

    // If it's a new design, set the unique ID for future saves
    if (!existingDesignId) {
      setExistingDesignId(saveDesignData.unique_id);
    }
  };

  return (
    <>
      {designId && !isSaveDesignPopup ? (
        <Popup
          show={setSaveSharePopup}
          setShow={setSaveSharePopup}
          title="Rename Design"
        >
          <RenameProject
            oldName={"My First Project"}
            showRenamePopup={setSaveSharePopup}
          />
        </Popup>
      ) : (
        <Popup
          show={showSaveDesignPopUp}
          setShow={setSaveSharePopup}
          title="Save Design"
        >
          <SaveDesign
            closePopup={setSaveSharePopup}
            isLoggedIn={false}
            isSaving={false}
            onSaveDesign={handleSaveDesign}
          />
        </Popup>
      )}

      <Popup
        show={showSharePopup}
        setShow={setSaveSharePopup}
        title="Share Your Design"
      >
        <ShareDesign
          closePopup={showSaveDesignPopUp}
          show={showSharePopup}
          shareURL={shareURL}
          setSaveSharePopup={setSaveSharePopup}
        />
      </Popup>
    </>
  );
};

export default ShareAndSave;
